import { ListResponseModel, QueryParamModel, ReadingCenterModel } from 'models';
import request, { Methods, requestFile } from 'utils/request';
import { EntityService } from 'utils/entityService';
import { exportFile } from 'utils/exportFile';
import { Mock } from 'utils/mockDecorator';
import { mockListResponse } from 'mock/list';

class ReadingCenterService extends EntityService {
  constructor() {
    super('reading-center');
  }

  @Mock((params: QueryParamModel) =>
    import('mock/readingCenters').then((m) => mockListResponse(m.MOCK_READING_CENTERS, params))
  )
  async getReadingCenterList(params?: QueryParamModel | null) {
    return request<ListResponseModel<ReadingCenterModel>>({
      method: Methods.GET,
      resource: this.resource,
      params,
    });
  }

  async createReadingCenter(data: Partial<ReadingCenterModel>) {
    return request<ReadingCenterModel>({
      method: Methods.POST,
      resource: this.resource,
      data: { leaderName: data.leaderName, readingCenterId: data.readingCenterId },
    });
  }

  async editReadingCenter(id: ID, data: Partial<ReadingCenterModel>) {
    return request<ReadingCenterModel>({
      method: Methods.PATCH,
      resource: `${this.resource}/${id}`,
      data: { leaderName: data.leaderName, readingCenterId: data.readingCenterId },
    });
  }

  async deleteReadingCenter(id: ID) {
    return request({
      method: Methods.DELETE,
      resource: `${this.resource}/${id}`,
    });
  }

  async exportReadingCenters(params?: QueryParamModel | null) {
    const response = await requestFile<BlobPart>({
      method: Methods.GET,
      resource: `${this.resource}/export`,
      params,
    });

    exportFile(response);
    return response;
  }
}

export const readingCenterService = new ReadingCenterService();
